/* eslint-disable arrow-body-style */

import React from 'react';
import { TextInput } from '@abyss/web/ui/TextInput';
import {
  linkAnalysisFilterPanelApi,
  useLinkAnalysisFilterPanelStore,
} from '../../mothership/linkAnalysisFilterPanel.state';
import { linkAnalysisId } from '../../types';

export const ValueField = () => {
  const value = useLinkAnalysisFilterPanelStore((state) => state.value);
  const validationMsg = useLinkAnalysisFilterPanelStore(
    (state) => state.valueValidationMsg
  );

  const { submitKbd, setValue } = linkAnalysisFilterPanelApi;

  return (
    <div
      data-cy={`${linkAnalysisId}ValueField`}
      data-value={value}
      data-valid={!validationMsg}
    >
      <TextInput
        label="ID Value"
        placeholder="Enter Value"
        value={value}
        onChange={setValue}
        errorMessage={validationMsg}
        onKeyDown={submitKbd}
      />
    </div>
  );
};
